module.exports = __webpack_public_path__ + "static/media/no-result.f8e3a970.webp";